/**
 * 
 * This page contains reducers
 * 
 */

import {
    UPDATE_WHOLE_HOTSPOT_MAP_OBJECT,
    UPDATE_MODAL_LIST,
    SET_HOTSPOT_CLICKED_INDEX,
    SET_INCREMENT_CLICKED,
    SET_DECREMENT_CLICKED,
    SET_TOGGLE_HOTSPOT_VIEW,
    UPDATE_HOTSPOT_DATA_INTERIOR,
    SET_DROPDOWN_SELECTION,
    SET_INTERIOR_HOTSPOT_INDEX,
    SET_DECREMENT_CLICKED_INTERIOR,
    SET_INCREMENT_CLICKED_INTERIOR,
    SET_IS_360_INDEX,
    SET_IS_360_INT_INDEX,
    SET_TOGGLE_INTERIOR_HOTSPOT,
    UPDATE_INTERIOR360_URL
} from './View360ActionType'


// Initial state
const initialState = {
    hotSpotMapObj: new Map(), //map to store imagehotspot json,
    modalList: new Map(),
    hotspotClickedIndex: -1,
    interiorHotspotIndex: 0,
    incrementClicked: -1,
    decrementClicked: -1,
    toggleHotspotView: false,
    hotspotDataInterior: [],
    dropdownSelection: "EXT",
    incrementClickedInterior: -1,
    decrementClickedInterior: -1,
    is360Index: 0,
    toggleInteriorHotspots: false,
    is360IntIndex: 0,
    interior360Url: null
}
/********* IMAGE HOTSPOT JSON ***********/
//  {
//     imgId : '',
//     isHidden: false, //in case image or frame was deleted
//     imageHotSpots: [ // map of hotspots
//         {
//             hotSpotId: '', //skuId_imgId_seqNo,
//             hotSpotIconSrc: '',
//             coordinates: {
//                 xAxis: 0,
//                 yAxis: 0
//             },
//             timeStamp: {
//                 createdOn:'',
//                 updatedOn:''
//             },
//             hotSpotDesc:'',
//             hotSpotTitle:'',
//         }
//     ]

// }

export const view360Reducer = (state=initialState, action)=>{
    switch(action.type){
        case UPDATE_WHOLE_HOTSPOT_MAP_OBJECT : return {
            ...state,
            hotSpotMapObj: new Map(action.payload)
        }
        case UPDATE_MODAL_LIST:
            return {
                ...state,
                modalList: new Map(action.payload)
            }
        case SET_HOTSPOT_CLICKED_INDEX:
            return {
                ...state,
                hotspotClickedIndex: action.payload
            };
        case SET_INCREMENT_CLICKED:
            return {
                ...state,
                incrementClicked: action.payload
            }
        case SET_DECREMENT_CLICKED:
            return {
                ...state,
                decrementClicked: action.payload
            }
        case SET_TOGGLE_HOTSPOT_VIEW:
            return {
                ...state,
                toggleHotspotView: action.payload
                }
        case UPDATE_HOTSPOT_DATA_INTERIOR:
            return {
                ...state,
                hotspotDataInterior: action.payload
            }
        case SET_DROPDOWN_SELECTION:
            return {
                ...state,
                dropdownSelection: action.payload,
            }
        case SET_INTERIOR_HOTSPOT_INDEX:
            return {
                ...state,
                interiorHotspotIndex: action.payload,
            }
        case SET_INCREMENT_CLICKED_INTERIOR:
            return {
                ...state,
                incrementClickedInterior: action.payload,
            }
        case SET_DECREMENT_CLICKED_INTERIOR:
            return {
                ...state,
                decrementClickedInterior: action.payload,
            }
        case SET_IS_360_INDEX:
            return {
                ...state,
                is360Index: action.payload,
            }
        case SET_TOGGLE_INTERIOR_HOTSPOT:
            return {
                ...state,
                toggleInteriorHotspots: action.payload,
            };
        case SET_IS_360_INT_INDEX:
            return {
                ...state,
                is360IntIndex: action.payload,
            };
        case UPDATE_INTERIOR360_URL:
            return {
                ...state,
                interior360Url: action.payload,
            };
        default : return state
    }

}